import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform
{
  public transform(value: string): any
  {
    const tmp = document.createElement('div');
    tmp.innerHTML = value;
    return tmp.textContent || tmp.innerText || '';
  }
}
